import firebase from "firebase/app";

import { useTranslation } from "react-i18next";

import updateArticle from "astrid-firestore/src/api/articles/updateArticle";
import distributeArticles from "astrid-firestore/src/api/distribution/distributeArticles";
import formatDate from "astrid-helpers/src/formatDate";

import { useProfile } from "../../../../authentication/state/profile";
import ConfirmationModal from "../../../../ui/components/ConfirmationModal/ConfirmationModal";

import getEnableDisableArticleChannelTexts from "../hooks/useEnableDisableArticleChannelTexts";
import shouldDoTakedownOrDisable from "../utils/shouldDoTakedownOrDisable";

export default function ConfirmEnableDisableChannel({ article, channel, onClose }) {
	const { t } = useTranslation();

	const user = useProfile();

	const enableDisableChannelText = getEnableDisableArticleChannelTexts({ t, channel, article });

	const onConfirmUnpublish = async () => {
		const action = shouldDoTakedownOrDisable({ article, channel });

		const channelIds = ["DISABLE", "TAKEDOWN"].includes(action)
			? article.channelIds.filter((id) => id !== channel.id)
			: [...article.channelIds, channel.id];

		// a takedown that has already passed would filter the channel out again on save,
		// enabling the channel cancels it so the article can be re-activated
		const { takedownDate } = article.channels?.[channel.id] || {};

		const clearTakedownDate = action === "ENABLE" && takedownDate && takedownDate <= formatDate();

		await updateArticle(
			firebase,
			{
				ref: article.ref,
				channelIds,
				...(clearTakedownDate && { channels: { [channel.id]: { takedownDate: null } } }),
			},
			{ user },
		);

		if (action === "TAKEDOWN") {
			await distributeArticles(firebase, {
				articles: [article],
				delivery: {
					[channel.id]: {
						metadata: true,
						artifact: false,
					},
				},
			});
		}
	};

	return (
		<ConfirmationModal
			header={`${channel.name}`}
			text={t("enableDisableChannelConfirm", "Are you sure you wish to {{action}}?", {
				action: enableDisableChannelText.toLowerCase(),
			})}
			onConfirm={onConfirmUnpublish}
			onClose={onClose}
		/>
	);
}
